import PhoneOTPModal from './PhoneOTPModal';

export default PhoneOTPModal;
